import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Paragraph--Streamline-Flex"
    >
        <desc>{'Paragraph Streamline Icon: https://streamlinehq.com'}</desc>
        <g id="paragraph--alignment-paragraph-formatting-text">
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.9771 0.672607c0.1814 4.977573 0.1918 7.779133 0 12.827493"
                strokeWidth={1}
            />
            <path
                id="Vector_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.39727 0.672607c-0.05562 5.070543 -0.05586 7.879403 0 12.827493"
                strokeWidth={1}
            />
            <path
                id="Vector_2_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.36334 9.61038c-0.32986 0.03038 -0.67542 0.04574 -1.03625 0.04574C2.59775 9.65612 0.5 8.01576 0.5 5.09958 0.5 2.18339 2.59775 0.543038 6.32709 0.543038 8.31178 0.451083 10.543 0.512115 13.5 0.672509"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
